module.exports = __webpack_public_path__ + "static/media/chingu.002c06f4.jpg";